import React from 'react';
import AnimatedSection from '../components/blocks/AnimatedSection';

const ContactUs = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="text-center mt-8 mb-16">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Contact Us</h1>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto text-center">
                        Get in touch with us for inquiries, support, or collaboration opportunities.
                    </p>
                </div>

                {/* Contact Information */}
                <AnimatedSection
                    className="mb-16"
                    heading={<h2 className="text-3xl font-semibold text-gray-900 mb-8">Contact Information</h2>}
                >
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="grid md:grid-cols-2 gap-8">
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">Email</h3>
                                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                                    For general inquiries, please reach out to us via email.
                                </p>
                                <a
                                    href="mailto:titanprojectshk@gmail.com"
                                    className="inline-block px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-orange-400 hover:text-orange-600 transition"
                                >
                                    Email Us
                                </a>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">Social Media</h3>
                                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                                    Follow us on Instagram for the latest updates and announcements.
                                </p>
                                <div className="flex flex-col sm:flex-row gap-4">
                                    <a
                                        href="https://instagram.com/titanprojectshk"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-block px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-orange-400 hover:text-orange-600 transition"
                                    >
                                        @titanprojectshk
                                    </a>
                                    <a
                                        href="https://instagram.com/cortex.hku"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-block px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-blue-400 hover:text-blue-600 transition"
                                    >
                                        @cortex.hku
                                    </a>
                                    <a
                                        href="https://instagram.com/jeltr.hk"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-block px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-purple-400 hover:text-purple-600 transition"
                                    >
                                        @jeltr.hk
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </AnimatedSection>

                {/* Contact Form */}
                <AnimatedSection
                    className="mb-16"
                    heading={<h2 className="text-3xl font-semibold text-gray-900 mb-8">Send us a Message</h2>}
                >
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <form className="space-y-6" action="mailto:it.cortex.titan.hku@hotmail.com" method="post" enctype="text/plain">
                            <div className="grid md:grid-cols-2 gap-6">
                                <div>
                                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2">
                                        First Name *
                                    </label>
                                    <input
                                        type="text"
                                        id="firstName"
                                        name="firstName"
                                        required
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2">
                                        Last Name *
                                    </label>
                                    <input
                                        type="text"
                                        id="lastName"
                                        name="lastName"
                                        required
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>
                            </div>
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                    Email Address *
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>
                            <div>
                                <label htmlFor="organization" className="block text-sm font-medium text-gray-700 mb-2">
                                    Organization/Institution
                                </label>
                                <input
                                    type="text"
                                    id="organization"
                                    name="organization"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>
                            <div>
                                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                                    Subject *
                                </label>
                                <select
                                    id="subject"
                                    name="subject"
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                >
                                    <option value="">Select a subject</option>
                                    <option value="general">General Inquiry</option>
                                    <option value="support">Technical Support</option>
                                    <option value="research">Research Collaboration</option>
                                    <option value="partnership">Partnership Opportunity</option>
                                    <option value="media">Media Inquiry</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                            <div>
                                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                                    Message *
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows={6}
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    placeholder="Please provide details about your inquiry..."
                                ></textarea>
                            </div>
                            <div className="flex items-center">
                                <input
                                    id="newsletter"
                                    name="newsletter"
                                    type="checkbox"
                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                />
                                <label htmlFor="newsletter" className="ml-2 block text-sm text-gray-700">
                                    Subscribe to our newsletter for updates and announcements
                                </label>
                            </div>
                            <div className="text-center">
                                <button
                                    type="submit"
                                    className="px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-orange-400 hover:text-orange-600 transition"
                                >
                                    Send Message
                                </button>
                            </div>
                        </form>
                    </div>
                </AnimatedSection>

                {/* TEMPLATE CONTENT - HIDDEN BUT PRESERVED */}
                {/* 
                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Contact Information</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                            <div className="text-center">
                                <div className="w-16 h-16 bg-blue-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                    <span className="text-2xl">📍</span>
                                </div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-2">Address</h3>
                                <p className="text-gray-700">
                                    TITAN Headquarters<br />
                                    123 Education Avenue<br />
                                    Academic District<br />
                                    Hong Kong
                                </p>
                            </div>
                            <div className="text-center">
                                <div className="w-16 h-16 bg-green-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                    <span className="text-2xl">📞</span>
                                </div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-2">Phone</h3>
                                <p className="text-gray-700">
                                    General Inquiries: +852 1234 5678<br />
                                    Technical Support: +852 1234 5679<br />
                                    Research Collaboration: +852 1234 5680
                                </p>
                            </div>
                            <div className="text-center">
                                <div className="w-16 h-16 bg-purple-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                    <span className="text-2xl">✉️</span>
                                </div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-2">Email</h3>
                                <p className="text-gray-700">
                                    General: info@titan.org<br />
                                    Support: support@titan.org<br />
                                    Research: research@titan.org<br />
                                    Media: media@titan.org
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Send us a Message</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <form className="space-y-6">
                            <div className="grid md:grid-cols-2 gap-6">
                                <div>
                                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2">
                                        First Name *
                                    </label>
                                    <input
                                        type="text"
                                        id="firstName"
                                        name="firstName"
                                        required
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2">
                                        Last Name *
                                    </label>
                                    <input
                                        type="text"
                                        id="lastName"
                                        name="lastName"
                                        required
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    />
                                </div>
                            </div>
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                    Email Address *
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>
                            <div>
                                <label htmlFor="organization" className="block text-sm font-medium text-gray-700 mb-2">
                                    Organization/Institution
                                </label>
                                <input
                                    type="text"
                                    id="organization"
                                    name="organization"
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                />
                            </div>
                            <div>
                                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-2">
                                    Subject *
                                </label>
                                <select
                                    id="subject"
                                    name="subject"
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                >
                                    <option value="">Select a subject</option>
                                    <option value="general">General Inquiry</option>
                                    <option value="support">Technical Support</option>
                                    <option value="research">Research Collaboration</option>
                                    <option value="partnership">Partnership Opportunity</option>
                                    <option value="media">Media Inquiry</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                            <div>
                                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                                    Message *
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    rows={6}
                                    required
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                    placeholder="Please provide details about your inquiry..."
                                ></textarea>
                            </div>
                            <div className="flex items-center">
                                <input
                                    id="newsletter"
                                    name="newsletter"
                                    type="checkbox"
                                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                                />
                                <label htmlFor="newsletter" className="ml-2 block text-sm text-gray-700">
                                    Subscribe to our newsletter for updates and announcements
                                </label>
                            </div>
                            <div className="text-center">
                                <button
                                    type="submit"
                                    className="px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-semibold hover:border-blue-400 hover:text-blue-600 transition"
                                >
                                    Send Message
                                </button>
                            </div>
                        </form>
                    </div>
                </section>

                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Department Contacts</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="grid md:grid-cols-2 gap-8">
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">TITAN</h3>
                                <div className="space-y-4">
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">Career Guidance</h4>
                                        <p className="text-gray-600 text-sm mb-2">For questions about career planning and trajectory analysis</p>
                                        <p className="text-blue-600">career@titan.org</p>
                                    </div>
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">Platform Support</h4>
                                        <p className="text-gray-600 text-sm mb-2">Technical issues and platform assistance</p>
                                        <p className="text-blue-600">support@titan.org</p>
                                    </div>
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">Partnerships</h4>
                                        <p className="text-gray-600 text-sm mb-2">Institutional partnerships and collaborations</p>
                                        <p className="text-blue-600">partnerships@titan.org</p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">CORTEX</h3>
                                <div className="space-y-4">
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">Research Collaboration</h4>
                                        <p className="text-gray-600 text-sm mb-2">Research projects and collaboration opportunities</p>
                                        <p className="text-green-600">research@cortex.org</p>
                                    </div>
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">Technology Platform</h4>
                                        <p className="text-gray-600 text-sm mb-2">Technical support for CORTEX platform</p>
                                        <p className="text-green-600">tech@cortex.org</p>
                                    </div>
                                    <div className="p-4 border rounded-lg">
                                        <h4 className="font-semibold text-gray-900">Events & Workshops</h4>
                                        <p className="text-gray-600 text-sm mb-2">Information about upcoming events and workshops</p>
                                        <p className="text-green-600">events@cortex.org</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-8">
                            <h3 className="text-xl font-semibold text-gray-900 mb-4">JELTR</h3>
                            <div className="grid md:grid-cols-3 gap-4">
                                <div className="p-4 border rounded-lg">
                                    <h4 className="font-semibold text-gray-900">Manuscript Submissions</h4>
                                    <p className="text-gray-600 text-sm mb-2">For authors submitting research papers</p>
                                    <p className="text-purple-600">submissions@jeltr.org</p>
                                </div>
                                <div className="p-4 border rounded-lg">
                                    <h4 className="font-semibold text-gray-900">Editorial Inquiries</h4>
                                    <p className="text-gray-600 text-sm mb-2">Editorial board and review process</p>
                                    <p className="text-purple-600">editorial@jeltr.org</p>
                                </div>
                                <div className="p-4 border rounded-lg">
                                    <h4 className="font-semibold text-gray-900">Publication Support</h4>
                                    <p className="text-gray-600 text-sm mb-2">Publication process and formatting assistance</p>
                                    <p className="text-purple-600">publications@jeltr.org</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Patronage</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="text-center mb-8">
                            <h3 className="text-2xl font-semibold text-gray-900 mb-4">Support Our Mission</h3>
                            <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto text-justify">
                                Your support helps us continue providing valuable services to students, researchers, and educators worldwide.
                                Consider becoming a patron to help us expand our impact and reach.
                            </p>
                        </div>

                        <div className="grid md:grid-cols-3 gap-8 mb-8">
                            <div className="text-center p-6 border rounded-lg">
                                <div className="w-16 h-16 bg-blue-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                    <span className="text-2xl">🎓</span>
                                </div>
                                <h4 className="text-xl font-semibold text-gray-900 mb-2">Student Support</h4>
                                <p className="text-gray-600 text-sm mb-4">Help us provide free career guidance and educational resources to students</p>
                                <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors">
                                    Support Students
                                </button>
                            </div>
                            <div className="text-center p-6 border rounded-lg">
                                <div className="w-16 h-16 bg-green-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                    <span className="text-2xl">🔬</span>
                                </div>
                                <h4 className="text-xl font-semibold text-gray-900 mb-2">Research Funding</h4>
                                <p className="text-gray-600 text-sm mb-4">Support innovative research projects and collaborative initiatives</p>
                                <button className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors">
                                    Fund Research
                                </button>
                            </div>
                            <div className="text-center p-6 border rounded-lg">
                                <div className="w-16 h-16 bg-purple-100 rounded-full mx-auto mb-4 flex items-center justify-center">
                                    <span className="text-2xl">📚</span>
                                </div>
                                <h4 className="text-xl font-semibold text-gray-900 mb-2">Academic Publishing</h4>
                                <p className="text-gray-600 text-sm mb-4">Help maintain open access publishing and academic excellence</p>
                                <button className="bg-purple-600 text-white px-6 py-2 rounded-lg hover:bg-purple-700 transition-colors">
                                    Support Publishing
                                </button>
                            </div>
                        </div>

                        <div className="bg-gray-50 rounded-lg p-6">
                            <h4 className="text-xl font-semibold text-gray-900 mb-4">Corporate Partnerships</h4>
                            <p className="text-gray-700 mb-4">
                                We welcome partnerships with organizations that share our commitment to education and research.
                                Corporate partners receive recognition and opportunities to engage with our community.
                            </p>
                            <div className="flex flex-wrap gap-4">
                                <button className="bg-gray-800 text-white px-6 py-2 rounded-lg hover:bg-gray-900 transition-colors">
                                    Become a Corporate Partner
                                </button>
                                <button className="border border-gray-300 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-50 transition-colors">
                                    View Partnership Benefits
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Office Hours</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="grid md:grid-cols-2 gap-8">
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">General Office Hours</h3>
                                <div className="space-y-2 text-gray-700">
                                    <div className="flex justify-between">
                                        <span>Monday - Friday</span>
                                        <span>9:00 AM - 6:00 PM (HKT)</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span>Saturday</span>
                                        <span>10:00 AM - 4:00 PM (HKT)</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span>Sunday</span>
                                        <span>Closed</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900 mb-4">Emergency Support</h3>
                                <p className="text-gray-700 mb-4">
                                    For urgent technical issues or critical inquiries, our emergency support team is available 24/7.
                                </p>
                                <div className="space-y-2">
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Emergency Hotline:</span> +852 1234 9999
                                    </p>
                                    <p className="text-gray-700">
                                        <span className="font-semibold">Emergency Email:</span> emergency@titan.org
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="mb-16">
                    <h2 className="text-3xl font-semibold text-gray-900 mb-8">Connect With Us</h2>
                    <div className="bg-white rounded-lg shadow-md p-8">
                        <div className="text-center">
                            <p className="text-lg text-gray-700 mb-8">
                                Follow us on social media for the latest updates, news, and community discussions.
                            </p>
                            <div className="flex justify-center space-x-6">
                                <a href="#" className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center text-white hover:bg-blue-700 transition-colors">
                                    <span className="text-xl">f</span>
                                </a>
                                <a href="#" className="w-12 h-12 bg-blue-400 rounded-full flex items-center justify-center text-white hover:bg-blue-500 transition-colors">
                                    <span className="text-xl">t</span>
                                </a>
                                <a href="#" className="w-12 h-12 bg-blue-800 rounded-full flex items-center justify-center text-white hover:bg-blue-900 transition-colors">
                                    <span className="text-xl">in</span>
                                </a>
                                <a href="#" className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center text-white hover:bg-red-700 transition-colors">
                                    <span className="text-xl">yt</span>
                                </a>
                                <a href="#" className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center text-white hover:bg-purple-700 transition-colors">
                                    <span className="text-xl">ig</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                */}
            </div>
        </div>
    );
};

export default ContactUs;
